import React from 'react';
import { t } from '@sm/intl';

import { Link } from 'react-router-dom';
import { Box } from '@wds/box';
import { PackageProps } from '~shared/types/pricing/package';

import PackageCta from '../PackageCta';
import PackageHeader from '../PackageHeader';
import usePackageStyles from './useStyles';
import FeatureSet from '~pricing/components/FeatureSet';
import useTrackingDetails from '~pricing/hooks/useTrackingDetails';
import useSummaryDisplayFeatures from '~pricing/hooks/useSummaryDisplayFeatures';
import PackageDefs from '~pricing/lib/packages/packageDefs';
import { PackageDefs as Grow2792PackageDefs } from '../../constants';

import COPY from '~pricing/copy';

const expPackageDefs = { ...PackageDefs, ...Grow2792PackageDefs };

export default function Package({
  skuCost,
  packageName,
  features,
  comparePlans,
  isLastPackage,
  discountInfo,
}: PackageProps): React.ReactElement | null {
  const displayFeatures = useSummaryDisplayFeatures(features, packageName);

  const { PricingPackageContainer, PricingPackage, Highlighted, PlanFeaturesLink } = usePackageStyles({
    packageName,
  });
  const { pageUtSource } = useTrackingDetails();

  if (!displayFeatures) {
    return null;
  }

  return (
    <Box
      element="article"
      className={`${PricingPackageContainer} package-${packageName}`}
      key={packageName}
      data-testid="Package"
    >
      <Box className={`${PricingPackage} ${expPackageDefs[packageName]?.highlighted ? Highlighted : ''}`}>
        <PackageHeader packageName={packageName} skuCosts={skuCost} isSummaryPage discountInfo={discountInfo} />
        <FeatureSet features={displayFeatures} packageName={packageName} isLastPackage={isLastPackage} />
        {!comparePlans && (
          <Box className={PlanFeaturesLink}>
            <Link to={`/pricing/details?ut_source=${pageUtSource}`}>{t(COPY.PLAN_FEATURES)}</Link>
          </Box>
        )}
      </Box>
      <PackageCta packageName={packageName} isSummaryPage />
    </Box>
  );
}
